import { CallButton, WhatsAppButton } from "./ContactButtons";
import { SpineMotif } from "@/components/brand/SpineMotif";

export const CtaBand = ({ title = "Ready to book your consultation?", text }) => (
  <section className="relative overflow-hidden bg-gradient-to-br from-brand-blue via-brand-blueBright to-brand-skyDeep">
    <span className="blob -right-16 -top-20 h-72 w-72 bg-brand-lime/30" aria-hidden="true" />
    <span className="blob -bottom-24 left-1/4 h-64 w-64 bg-brand-sun/25" aria-hidden="true" />
    <SpineMotif className="pointer-events-none absolute right-6 top-1/2 hidden h-[240px] -translate-y-1/2 text-white/15 lg:block" count={10} />
    <div className="container-x relative flex flex-col items-start justify-between gap-6 py-12 md:flex-row md:items-center md:py-16 lg:pr-24">
      <div className="max-w-2xl">
        <h2 className="text-2xl font-bold text-white sm:text-3xl">{title}</h2>
        <p className="mt-2 text-base text-blue-50 md:text-lg">
          {text || "In-person consultations at our Mohali clinic, by prior appointment. Call or WhatsApp us to book."}
        </p>
      </div>
      <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
        <CallButton tone="white" testid="cta-call-btn" />
        <WhatsAppButton testid="cta-whatsapp-btn" className="ring-1 ring-white/30" />
      </div>
    </div>
  </section>
);
